export default __webpack_public_path__ + "static/media/1.850c140a.png";